<template>
    <van-cell :title="title" :label="label" :required="required" class="upload-image-title">
        <ul class="upload-image-container">
            <li v-for="(item, index) in imageList" :key="index" class="image-list-container">
                <div class="image-delete-div">
                    <img src="~@public/img/application/delete.png" class="delete-img" @click="deleteImg(index)"/>
                    <img :src="item.file.content" @click="amplification(item)" class="img-list"/>
                </div>
            </li>
            <van-uploader accept="image/*" v-model="list" :max-count="maxLength" :max-size="maxSizeNum"
                          @oversize="onOversize" :after-read="onRead">
                <img src="~@public/img/application/download.png" class="img-upload"/>
            </van-uploader>
        </ul>
    </van-cell>
</template>

<script>
  /**
   * Description: 上传图片组件
   * Author: Wangyan
   * Date: 2019-04-04
   * Time: 19:30
   */

  import { Cell, Uploader, Toast, ImagePreview, Dialog } from 'vant'
  import { storageApiMap } from "@/api/storage";

  export default {
    name: "UploadImage",
    components: {
      [Cell.name]: Cell,
      [Uploader.name]: Uploader,
      [Toast.name]: Toast,
      [ImagePreview.name]: ImagePreview,
      [Dialog.name]: Dialog,
    },
    props: {
      // 容缺受理数据上传用
      tolerance: {
        type: Boolean,
        default: false
      },
      // 区分"线索举报"与"事项"最后上传的数据类型
      report: {
        type: Boolean,
        default: false
      },
      // 上传图片标题
      title: {
        type: String,
        default: ''
      },
      // 上传图片的备注
      label: {
        type: String,
        default: ''
      },
      // 上传图片大小的最大值
      maxSize: {
        type: Number,
        default: 4 // 这里的默认值根据后台所设计的文件最大值来得倒的
      },
      // 上传图片数量的最大值
      maxLength: {
        type: Number,
        default: 2,
      },
      // "必填"小红星的显示与隐藏
      required: {
        type: Boolean,
        default: false
      },
      // 上图片的接口地址
      uploadPath: {
        type: String,
        default: global.storageUrl + '/storage/upload'
      },
      // 父组件传过来事项的matID
      matId: {
        type: String,
        default: ''
      }
    },
    data() {
      return {
        maxSizeNum: this.maxSize * 1024 * 1024, // 根据maxSize值计算出上传的最大值
        imageList: [], // 存放上传图片的信息
        list: [], // 存放上传图片原本信息
        amplificationImg: null, // 存放图片预览的状态
      }
    },
    methods: {
      /**
       * 上传图片
       * @param file 上传的图片的信息
       */
      async onRead(file) {
        if (this.imageList.length < this.maxLength) {
          Toast.loading({
            duration: 0,       // 持续展示 toast
            forbidClick: true, // 禁用背景点击
            loadingType: 'spinner',
            message: '上传中...'
          })
          try {
            const form = new FormData()

            form.append("file", file.file)
            const res = await this.$httpUtils.postCommonUtils(storageApiMap.uploadAtt, form)
            if (res.data.succ) {
              this.$set(res.data.data, 'file', file)
              res.data.data.file.uid = new Date().getTime() // 给图片生成一个uid时间戳
              res.data.data.matId = this.matId
              this.imageList.push(res.data.data)
              // this.passImageValue()
              Toast.clear()
              Toast.success('上传成功')
            } else {
              Toast.fail('上传失败')
            }
          } catch (error) {
            Toast.fail('材料上传失败，大小需控制在 3MB 内，多次上传失败请登录 PC 端办理！！！')
          }
        } else {
          Toast.fail(`图片上传不能超过${this.maxLength}张`)
        }
      },

      /**
       * 超出图片大小的提示方法
       */
      onOversize() {
        Toast.fail(`图片大小不能超过${this.maxSize}MB`)
      },

      /**
       * 图片预览
       * @param item 图片的信息
       */
      amplification(item) {
        this.amplificationImg = ImagePreview({
          images: [item.file.content],
          showIndex: false,
        })
      },

      /**
       * 删除图片
       * @param index 图片的下标
       */
      async deleteImg(index) {
        Dialog.confirm({
          title: '提示',
          message: '是否删除此图片？'
        }).then(async () => {
          Toast.loading({
            duration: 0,       // 持续展示 toast
            forbidClick: true, // 禁用背景点击
            loadingType: 'spinner',
            message: '删除中...'
          })
          try {
            const data = {
              file_id: this.imageList[index].guid
            }
            const res = await this.$httpUtils.postCommonUtils(`${storageApiMap.deleteAtt}?file_id=${this.imageList[index].guid}`)
            if (res.data.data && res.data.succ) {
              this.imageList.splice(index, 1)
              this.list.splice(index, 1)
              // this.passImageValue()
              Toast.clear()
            } else {
              Toast.fail('删除失败')
            }
          } catch (error) {
            Toast.fail('服务器运行失败，请稍后再试。')
          }
        }).catch(() => {
        })
      },

      /**
       * 关闭图片预览
       */
      closePreview() {
        if (this.amplificationImg) {
          this.amplificationImg.close()
        }
      },

      /**
       * 传值给父组件
       */
      passImageValue() {
        let list = []
        let data = {}
        //存放容缺受理数据结构
        if (this.tolerance) {
          for (let index in this.imageList) {
            data = {
              uid: this.imageList[index].file.uid,
              guid: this.imageList[index].guid,
              tmguid: this.matId,
              mime: this.imageList[index].mime,
              contentsize: this.imageList[index].size,
              filename: this.imageList[index].name,
              realfilename: this.imageList[index].name,
              filepath: this.imageList[index].url,
              attachtype: 0
            }
            list.push(data)
          }
          this.$emit('setImageInfo', list)

          // 判断必上传的图片是否上传
          if (this.required && list.length <= 0) {
            this.$emit('setIsImages', false)
          } else {
            this.$emit('setIsImages', true)
          }
          return;
        }
        // report用来区分"线索举报"与"事项"两种不同的图片参数
        if (this.report) {
          for (let index in this.imageList) {
            data = {
              uid: this.imageList[index].file.uid,
              guid: this.imageList[index].guid,
              fsize: this.imageList[index].size,
              fname: this.imageList[index].name,
              attachtype: 0
            }
            list.push(data)
          }
        }
        if (!this.report) {
          for (let index in this.imageList) {
            data = {
              uid: this.imageList[index].file.uid,
              guid: this.imageList[index].guid,
              matMId: this.imageList[index].matId,
              fileSize: this.imageList[index].size,
              fileRealName: this.imageList[index].name,
              url: this.imageList[index].url,
              titleGuid: this.imageList[index].matId
            }
            list.push(data)
          }
        }
        this.$emit('setImageInfo', list)

        // 判断必上传的图片是否上传
        if (this.required && list.length <= 0) {
          this.$emit('setIsImages', false)
        } else {
          this.$emit('setIsImages', true)
        }
      }
    }
  }
</script>

<style lang="less" scoped>
    .upload-image-title {
        flex-direction: column;
        -webkit-flex-direction: column;
        align-items: baseline;
        -webkit-align-items: baseline;
    }

    .upload-image-container {
        width: 100%;
        text-align: left;
        margin-top: 0.1rem;
    }

    .image-list-container {
        display: inline-block;
    }

    .image-delete-div {
        position: relative;
    }

    .img-list {
        width: 1.4rem;
        height: 1.4rem;
        border-radius: 0.3rem;
        margin-top: 0.26666rem;
        margin-right: 0.23rem;
    }

    .delete-img {
        width: 0.4rem;
        position: absolute;
        top: 0.1rem;
        right: 0.1rem;
    }

    .img-upload {
        width: 1.4rem;
        margin-top: 0.26666rem;
    }
</style>
<style>
    /*隐藏上传图片后原来的样式和删除按钮*/
    .van-uploader__preview-image {
        display: none;
    }

    .van-uploader__preview-delete {
        display: none;
    }
</style>
